/*
    Renders basic shared UI, such as the top right bar or bottom left bar, as well as initial load UI like welcome scene
    and pop up, and transition into first scene. Global UI that persists across rooms such probably be placed here
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Welcome from './welcome/Welcome.jsx';
import PromoPage from './welcome/PromoPage.jsx';
import Logo from './Logo.jsx';
import TopBarRight from './TopBarRight.jsx';
import BottomBarRight from './BottomBarRight.jsx';
import BottomBarLeft from './BottomBarLeft.jsx';
import {
    getEntranceAutoTransitionAysnc,
    getSceneIds,
    getAllSceneInfoDictAsync,
    getStoreSelectorExistAsync,
    getStoreId,
    getCurrentLiveUserCountAsync,
    exhibitStoreId
} from '../../utils/StoreConfigManager.js';
import { arrowScenes, getCurrentSceneName } from '../../utils/StaticAssetManager';
import { getAutoRotate, getTopRightBarToBottomLeftBar } from '../../utils/EmbedVariable';
import { isMobileDevice } from '../../utils/DeviceDetector';

import { AppContext } from '../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import { FlatImageSceneContext } from '../flat-image-scene/FlatImageSceneContextComponent'
import './TopUILayer.css';
import { EntranceAnimationContext } from '../entrance-animation/EntranceAnimationContextComponent';
import SpotifyPlayerModal from './modals/spotify-player-modal/SpotifyPlayerModal.jsx';
import { storeId } from '../../../../variables/Variables.js';
import { LeftArrowClicked, RightArrowClicked } from '../../utils/Analytics.js';

const autoRotate = getAutoRotate();
const moveTopRightBarToBottomLeft = getTopRightBarToBottomLeftBar();
const isMobile = isMobileDevice();
const updateUserCountInterval = 10000;
const isExhibit = storeId === exhibitStoreId;
/*
    Renders basic shared UI, such as the top right bar or bottom left bar, as well as initial load UI like welcome scene
    and pop up, and transition into first scene. Global UI that persists across rooms should probably be placed here
 */

class TopUILayer extends Component {
    constructor(props) {
        super(props);
        this.hideUserPanel = this.hideUserPanel.bind(this);
        this.onWelcomeHide = this.onWelcomeHide.bind(this);
        this.toggleTipPanel = this.toggleTipPanel.bind(this);
        this.initStoreScene = this.initStoreScene.bind(this);
        this.toggleUserPanel = this.toggleUserPanel.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        
        this.state = {
            showingWelcome: this.initStoreScene(),
            hasStoreSelector: false,
            showingTipsMenu: false,
            sharePanelOpen: false,
            userPanelOpen: false,
            userCount: null
        };
        this.autoTranstionToSceneIndex = 0;
    }

    componentDidMount() {
        getEntranceAutoTransitionAysnc()
            .then(autoTransition => {
                this.autoTranstionEntrance = autoTransition
            })
            .catch(error => console.error(error));

        getStoreSelectorExistAsync()
            .then(hasStoreSelector => this.setState({ hasStoreSelector: hasStoreSelector }))
            .catch(error => console.error(error));

        if (this.props.setRoomObjectVisibility) {
            this.props.setRoomObjectVisibility(true);
        }
    }

    initStoreScene() {
        const dragTooltipEncountered = sessionStorage.getItem('dragTooltipEncountered')
        // If drag tooltip has been shown this session, show the tooltip
        const sceneName = getCurrentSceneName();
        if (!dragTooltipEncountered && (sceneName === 'entrance-1' || sceneName === '')) {
            return true;
        }

        this.props.setRoomObjectVisibility(true);
        return false;
    }

    onWelcomeHide() {
        this.setState({ showingWelcome: false });

        if (this.autoTranstionEntrance > 0) {
            this.props.setLoadingIconVisibility(true);
            let linkedRoomId = '';
            getSceneIds()
                .then(sceneIds => {
                    linkedRoomId = sceneIds[1];
                    return getAllSceneInfoDictAsync();
                })
                .then(sceneInfoDict => {
                    const sceneInfo = sceneInfoDict[linkedRoomId];
                    const linkedRoomName = sceneInfo['name'];
                    const targetPath = '/' + linkedRoomName;
                    this.props.history.push(targetPath);
                })
                .catch(error => console.error(error));
        }
    }

    toggleTipPanel(isShowing) {
        this.setState({
            showingTipsMenu: isShowing
        });
    }

    toggleUserPanel() {
        this.setState({
            sharePanelOpen: false,
            userPanelOpen: !this.state.userPanelOpen
        });
    }

    hideUserPanel() {
        this.setState({
            userPanelOpen: false
        })
    }

    getFlatImageSceneWelcomeComponent() {
        const { isFlatImageScene, flatImageButtonOption, flatImageButtonText } = this.props.flatImageSceneContextValue;
        return <Welcome
            showingUI={true}
            onWelcomeHide={this.onWelcomeHide}
            isFlatImageScene={isFlatImageScene}
            flatImageButtonOption={flatImageButtonOption}
            flatImageButtonText={flatImageButtonText}
        />
    }

    getWelcomeComponent() {
        const { showingUI } = this.props;
        const { showingWelcome } = this.state;
        const { isFlatImageScene } = this.props.flatImageSceneContextValue;
        
        if (isFlatImageScene) {
            return this.getFlatImageSceneWelcomeComponent();
        }

        if (showingWelcome) {
            if (autoRotate) {
                return <PromoPage
                    onWelcomeHide={this.onWelcomeHide}
                />
            }
            return <Welcome
                showingUI={showingUI}
                onWelcomeHide={this.onWelcomeHide}
            />
        }
    }

    getBottomBarLeft() {
        if (this.state.showingTipsMenu && isMobile) {
            return <React.Fragment />;
        }
        return <BottomBarLeft
            showSocial={this.state.hasStoreSelector}
            toggleUserPanel={this.toggleUserPanel}
            userPanel={this.state.userPanelOpen}
            userCount={this.state.userCount}
            isMobile={isMobile}
            hideUserPanel={this.hideUserPanel}
        />;
    }

    getLogo() {
        return this.props.hideLogo ? <React.Fragment /> : <Logo />
    }

    getTopBarRight() {
        const { isFlatImageScene } = this.props.flatImageSceneContextValue;
        return <TopBarRight showStoreSelector={this.state.hasStoreSelector}
            moveTopRightBarToBottomLeft={moveTopRightBarToBottomLeft} isFlatImageScene={isFlatImageScene}/>;
    }

    getSpotifyModal() {
        return storeId===exhibitStoreId ? <SpotifyPlayerModal welcomeScreenNumber={this.props.welcomeScreenNumber} /> : <></> ;
    }

    getTopUILayer() {
        const sceneName = getCurrentSceneName();
        return (
            <div id="top-layer-ui-container">
                {arrowScenes.includes(sceneName) &&
                    storeId === exhibitStoreId &&
                    this.curatedModeRightArrow()}
                {arrowScenes.includes(sceneName) &&
                    storeId === exhibitStoreId &&
                    this.curatedModeLeftArrow()}
                    
                {this.getWelcomeComponent()}
                {this.getSpotifyModal()}
                {this.getLogo()}
                {this.getTopBarRight()}
                <BottomBarRight toggleTipPanel={this.toggleTipPanel} />
                {this.getBottomBarLeft()}
            </div>
        )
    }

    handleNextClick(arrow) {
        const sceneName = getCurrentSceneName();
		if (arrow === 'right') {
            // view-1 to view-20
            if (sceneName !== 'view-22') {
                let viewNumber = sceneName.split("-")[1];
                viewNumber = parseInt(viewNumber) + 1;
                const targetPath = '/view-'+viewNumber;
                this.curatedViewNavigation(targetPath);
                isExhibit && RightArrowClicked(targetPath);
            }else{
                const targetPath = '/view-1';
                this.curatedViewNavigation(targetPath);
                isExhibit && RightArrowClicked(targetPath);
            }
		} else {
            // view-1 to view-20
            if (sceneName !== 'view-1') {
                let viewNumber = sceneName.split("-")[1];
                viewNumber = viewNumber - 1;
                const targetPath = '/view-'+viewNumber;
                this.curatedViewNavigation(targetPath);
                isExhibit && LeftArrowClicked(targetPath);
            }else{
                const targetPath = '/view-22';
                this.curatedViewNavigation(targetPath);
                isExhibit && LeftArrowClicked(targetPath);
            }
		}
	}

	curatedViewNavigation = (targetPath) => {
		const { controller, history } = this.props.threeJSWorldContext;
		history.push(targetPath);
        controller.controller.reset();
	}

    curatedModeRightArrow(){
        return (
            <div className="rightContainer">
                {isExhibit && <div className="rightHover"></div>}
                <div 
                    onClick={() => this.handleNextClick('right')}
                    className={"curated-mode-right-arrow" + (isExhibit && " arrowBtn")} 
                >
                </div>
            </div>
            )
    }

    curatedModeLeftArrow(){
        return (
                <div className="leftContainer">
                    {isExhibit && <div className="leftHover"></div>}
                        <div
                            onClick={() => this.handleNextClick('left')}
                            className={"curated-mode-left-arrow" + (isExhibit && " arrowBtn-left")}
                        >
                    </div>
                </div>
        )
    }

    render() {
        if (!this.props.showingUI || (!this.props.isAnimationVideoEnd && this.props.isEntranceAnimationScene)) {
            return <React.Fragment />;
        }
        return this.getTopUILayer();
    }
}

TopUILayer.propTypes = {
    history: PropTypes.object,
    hideLogo: PropTypes.bool,
    showingUI: PropTypes.bool,
    setRoomObjectVisibility: PropTypes.func,
    setLoadingIconVisibility: PropTypes.func,
    threeJSWorldContext: PropTypes.object
};

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContextValue => (
                    <FlatImageSceneContext.Consumer>
                        {flatImageSceneContextValue => (
                            <EntranceAnimationContext.Consumer>
                               {entranceAnimationContext => (
                                <TopUILayer
                                    {...props}
                                    history={threeJSWorldContextValue.history}
                                    setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                                    threeJSWorldContext={threeJSWorldContextValue}
                                    primaryColor={appContextValue.primaryColor}
                                    flatImageSceneContextValue={flatImageSceneContextValue}
                                    isAnimationVideoEnd={entranceAnimationContext.isAnimationVideoEnd}
                                    isEntranceAnimationScene={entranceAnimationContext.isEntranceAnimationScene}
                                    showSpotifyModal={appContextValue.showSpotifyModal}
                                    welcomeScreenNumber={appContextValue.welcomeScreenNumber}
                                    setWelcomeScreenNumber={appContextValue.setWelcomeScreenNumber}
                                />
                                )}
                            </EntranceAnimationContext.Consumer>        
                        )}
                    </FlatImageSceneContext.Consumer>
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
);